import {PAYMENT_REQUEST_START, PAYMENT_REQUEST_SUCCESS, PAYMENT_REQUEST_FAIL, PAYMENT_REQUEST_RESET} from './constants';
import {PaymentRequestActions, PaymentRequestState} from './types';

const initialState: PaymentRequestState = {
  loading: false,
  data: undefined,
  error: undefined,
};

const reducer = (
  state = initialState,
  action: PaymentRequestActions,
): PaymentRequestState => {
  switch (action.type) {
    case PAYMENT_REQUEST_START:
      return {
        ...initialState,
        loading: true,
      };
    case PAYMENT_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case PAYMENT_REQUEST_FAIL:
     return {
        ...state,
        loading: false,
        error: action.error,
      };
    case PAYMENT_REQUEST_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;
